export const TENANTS_LIST = "TENANTS_LIST";
